import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { InterfaceService } from '@app/interfaces';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var OpenAIService = /** @class */ (function (_super) {
    tslib_1.__extends(OpenAIService, _super);
    function OpenAIService(http) {
        var _this = _super.call(this) || this;
        _this.http = http;
        return _this;
    }
    OpenAIService.prototype.generateText = function (prompt) {
        return this.http.post(this.getApiUrl("getMessageAi"), prompt);
    };
    OpenAIService.prototype.endSession = function () {
        return this.http.get(this.getApiUrl("clearConversation"));
    };
    OpenAIService.prototype.getTags = function (value) {
        return this.http.post(this.getApiUrl("getReplaceMessageAi"), value);
    };
    OpenAIService.ngInjectableDef = i0.defineInjectable({ factory: function OpenAIService_Factory() { return new OpenAIService(i0.inject(i1.HttpClient)); }, token: OpenAIService, providedIn: "root" });
    return OpenAIService;
}(InterfaceService));
export { OpenAIService };
